import type { MatrixCellData, MatrixEntry } from './types';

export function buildMatrixGrid(
  matrix: MatrixEntry[]
): Map<string, MatrixCellData> {
  const grid = new Map<string, MatrixCellData>();

  for (const entry of matrix) {
    for (const pair of entry.likelihoodImpact) {
      const key = `${pair.likelihood}-${pair.impact}`;
      grid.set(key, {
        title: entry.title,
        value: entry.value,
        color: entry.color,
        likelihood: pair.likelihood,
        impact: pair.impact,
      });
    }
  }

  return grid;
}

export function getCellData(
  grid: Map<string, MatrixCellData>,
  likelihood: number,
  impact: number
): MatrixCellData | undefined {
  return grid.get(`${likelihood}-${impact}`);
}
